import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { SectionHelper } from '@wix/design-system';
import { InfoCircle } from '@wix/wix-ui-icons-common';
import { AppContextProvider } from '../../AppLoader';

export const EnableErrorSectionHelper: React.FC = observer(() => {
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { ownerAppStore: store },
      },
    },
  } = useContext(AppContextProvider);
  const { t } = useTranslation();
  if (!store.showEnableError) {
    return null;
  }
  return (
    <SectionHelper
      skin="danger"
      size="small"
      fullWidth
      showCloseButton
      showPrefixIcon
      prefixIcon={<InfoCircle size={18} />}
      onClose={() => (store.showEnableError = false)}
      dataHook="owner-app-enable-error"
    >
      {t('ops_something_went_wrong')}
    </SectionHelper>
  );
});
